import { render, staticRenderFns } from "./IcoConiclexOld.vue?vue&type=template&id=6b09e988"
import script from "./IcoConiclexOld.vue?vue&type=script&lang=js"
export * from "./IcoConiclexOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports